import dataLayerHelper from '../helpers/dataLayer';

const SAVE_FOR_DAYS = 1;

const alertBanner = {
  initialize(barElement) {
    this.$bar = $(barElement);

    if (this.$bar.length) {
      this.createEvents();

      setTimeout(() => {
        this.$bar.addClass('is-visible');
      }, 2000);
    }
  },

  createEvents() {
    this.$bar.on('click', '.js-site-alert-btn', () => {
      this.acceptedBanner();
    });

    this.$bar.on('submit', 'form', () => {
      this.acceptedBanner(7);
    });
  },

  /**
   * Saves a cookie with the given data
   * @param {String} name
   * @param {String} value
   * @param {Number} days
   * @return {void}
   */
  setBannerAlertCookie(name, value, days) {
    let expires = '';

    const HOURS_DAY = 24;
    const MINUTES_HOUR = 60;
    const SECONDS_MINUTE = 60;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * HOURS_DAY * MINUTES_HOUR * SECONDS_MINUTE * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
  },

  /**
   * @return {void}
   */
  acceptedBanner(expireInDays = 1) {
    this.$bar.css('display', 'none');

    const key = this.$bar.attr('data-site-alert-key');

    this.setBannerAlertCookie(key, expireInDays, SAVE_FOR_DAYS);

    dataLayerHelper.event('Alert banner', 'closed');
  },
};

export default {
  initialize() {
    const $bars = $('.js-site-alert');

    $bars.each((_index, bar) => {
      const inst = { ...alertBanner };
      inst.initialize(bar);
    });
  },
};
